import React, { useEffect, useState } from "react";
import InputField from "../../../../components/InputField";
import { getPhonePatternForQR } from "../../../../helper/functions";

interface Props {
  setValue: (value: string) => void;
  prefilledValue?: string;
  error?: string;
}

const GeneratePhoneQr: React.FC<Props> = ({
  setValue,
  prefilledValue,
  error,
}) => {
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    if (prefilledValue) {
      setPhoneNumber(prefilledValue);
    }
  }, [prefilledValue]);

  return (
    <InputField
      name="phone-no"
      value={phoneNumber}
      onChange={(e) => {
        setPhoneNumber(e.target.value);
        setValue(getPhonePatternForQR(e.target.value));
      }}
      error={error}
      type="text"
      label="Phone number"
      placeholder="Enter your phone number here..."
    />
  );
};

export default GeneratePhoneQr;
